/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.14",
    versionName: "0.7.0-nightly.2026.9.14",
    versionChannel: "nightly",
    buildDate: "2026-09-14T00:17:19.535Z",
    commitHash: "645c3540cc9fabcfc81e8b0de4f3fa60e722c0db",
};
